var _rect, _g, _rect2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLinkCoral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5680_77083",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 5,
    width: 10,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.2681,
    y: 4.81481,
    width: 5.72679,
    height: 8.36905,
    rx: 2.86339,
    transform: "rotate(45 15.2681 4.81481)",
    stroke: "black",
    strokeWidth: 1.31925
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5680_77083)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3568 9.10175L16.2021 2.94714L11.0641 8.08514L17.2188 14.2398L22.3568 9.10175ZM17.2186 14.2402L13.5552 10.5768L10.9083 13.2236L14.5718 16.8871L17.2186 14.2402Z",
    fill: "#FF6262"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5680_77083",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 9,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.04053,
    y: 19.141,
    width: 5.72679,
    height: 8.36905,
    rx: 2.86339,
    transform: "rotate(-135 9.04053 19.141)",
    stroke: "black",
    strokeWidth: 1.31925
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5680_77083)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.95184 14.8536L8.10645 21.0082L13.2444 15.8702L7.08984 9.71557L1.95184 14.8536ZM7.0895 9.71508L10.753 13.3785L13.3998 10.7317L9.73635 7.06824L7.0895 9.71508Z",
    fill: "#FF6262"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkCoral);
export default __webpack_public_path__ + "static/media/ic_link_coral.7124424b46d2a10e3d65c18e574bbd5b.svg";
export { ForwardRef as ReactComponent };